import { Button, notification } from "antd";
import { FC, useCallback, useEffect, useMemo } from "react";
import styles from "./VersionUpdater.module.less";
import { getWindowEnv } from "~/helpers/envConfig";
import { MAX_VERSION_CHANGED_REFRESH_TIMER_VALUE } from "~/constants/versionUpdater";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useGetEnvVersionFromFile } from "~/hooks/useGetEnvVersionFromFile";
import FormattedMessage from "../formattedMessage/FormattedMessage";

interface VersionUpdaterProps {}

const { AUTO_REFRESH_WHEN_VERSION_CHANGED: autoRefresh } = getWindowEnv();

export const VersionUpdater: FC<VersionUpdaterProps> = () => {
  const { versionChanged, setVersionChanged } = useGetEnvVersionFromFile();
  const [api, notificationContext] = notification.useNotification();

  const onClose = useCallback(() => {
    setVersionChanged(0);
  }, [setVersionChanged]);

  const munites = useMemo(() => {
    return MAX_VERSION_CHANGED_REFRESH_TIMER_VALUE - versionChanged;
  }, [versionChanged]);

  useEffect(() => {
    if (
      autoRefresh &&
      versionChanged >= MAX_VERSION_CHANGED_REFRESH_TIMER_VALUE
    ) {
      window.location.reload();
    }
  }, [versionChanged]);

  useEffect(() => {
    if (versionChanged)
      api.open({
        message: (
          <div className={styles.versionUpdaterNotificationTitle}>
            <ExclamationCircleOutlined style={{ color: "#e74c3c" }} />
            <FormattedMessage id="VersionUpdater.Notification.Title" />
          </div>
        ),
        description: (
          <div className={styles.versionUpdaterContainer}>
            <div className={styles.message}>
              {autoRefresh ? (
                <FormattedMessage
                  id="VersionUpdater.Notification.AutoRefreshMessage"
                  values={{ munites }}
                />
              ) : (
                <FormattedMessage id="VersionUpdater.Notification.Message" />
              )}
            </div>

            <div className={styles.buttons}>
              <Button.Group>
                <Button onClick={() => window.location.reload()}>
                  <FormattedMessage id="VersionUpdater.Button.SwitchNow" />
                </Button>
                <Button onClick={onClose}>
                  <FormattedMessage id="General.Label.LowerCaseCancel" />
                </Button>
              </Button.Group>
            </div>
          </div>
        ),
        duration: 0,
      });
  }, [versionChanged, setVersionChanged, api, onClose, munites]);

  return <>{notificationContext}</>;
};
